// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Un trait plein : reduire la fenetre du centre de communication.
 *
 * Fournie par le fondateur pendant les retouches du 06/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconWindowMinimize = createCustomIcon(
  'IconWindowMinimize',
  '0 0 240 240',
  <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M0 1200 l0 -130 1200 0 1200 0 0 130 0 130 -1200 0 -1200 0 0 -130z" />,
);
